import forOwn from 'mout/object/forOwn'
import values from 'mout/object/values'
import sortByPropText from '../content/manageSets/sortByPropText';
import getTimeManagementRating from './getTimeManagementRating'
import getPacingRating from './getPacingRating';
import getStaminaRating from './getStaminaRating';
import getNoBlanksRating from './getNoBlanksRating';
import getProcessOfEliminationRating from './getProcessOfEliminationRating';
import getPrecisionRating from './getPrecisionRating';
import getMotivationRating from './getMotivationRating';

export default function getTestTakingData(score, userAssessment, studentScoring) {
  const testTakingData = {
    timeManagement: getTimeManagementRating(userAssessment),
    pacing: getPacingRating(userAssessment),
    stamina: getStaminaRating(userAssessment),
    noBlanks: getNoBlanksRating(userAssessment, studentScoring),
    processOfElimination: getProcessOfEliminationRating(userAssessment),
    precision: getPrecisionRating(userAssessment),
    motivation: getMotivationRating(userAssessment, studentScoring)
  }
  return testTakingData
}

/*

  timeManagement: {
    stars: 2,
    clocks: {
      Composite: 8,
      English: 5,
      Math: 6,
      Reading: 9,
      Science: 5, 
    }

*/


// WEBPACK FOOTER //
// ./src/helpers/assessment/getTestTakingData.js